let imageResolver = () => 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1 1%22/%3E';
export function configureGuildHomeImages(resolver) { imageResolver = resolver; }
export const GUILD_HOME_THEMES = {
  default: { feature: null },
  forest: { feature: 'HALL_THEME_FOREST' },
  celestial: { feature: 'HALL_THEME_CELESTIAL' },
};

export const GUILD_HOME_ROOMS = [
  { key: 'news', icon: 'Newspaper' },
  { key: 'stammtisch', icon: 'MessagesSquare', feature: 'STAMMTISCH' },
  { key: 'roster', icon: 'Users' },
  { key: 'treasury', icon: 'Gem' },
  { key: 'bounties', icon: 'Map', feature: 'GROUP_HEROIC_ACTIONS' },
  { key: 'trophies', icon: 'Trophy', feature: 'TROPHY_ROOM' },
  { key: 'forge', icon: 'Hammer', artRoom: 'shop', purchaseFeature: 'BANNER_FORGE_ADVANCED' },
  { key: 'design', icon: 'Palette', artRoom: 'hall', purchaseAny: ['HALL_THEME_FOREST', 'HALL_THEME_CELESTIAL'] },
  { key: 'stats', icon: 'BarChart3', artRoom: 'trophies' },
  { key: 'settings', icon: 'Settings', artRoom: 'hall', adminOnly: true },
];

export function isGuildRoomLocked(roomKey, features = []) {
  const room = GUILD_HOME_ROOMS.find(item => item.key === roomKey);
  return Boolean(room?.feature && !features.includes(room.feature));
}

export function isGuildRoomUnpurchased(roomKey, features = []) {
  const room = GUILD_HOME_ROOMS.find(item => item.key === roomKey);
  if (room?.purchaseFeature) return !features.includes(room.purchaseFeature);
  return Boolean(room?.purchaseAny && !room.purchaseAny.some(feature => features.includes(feature)));
}

export function guildRoomShopFeature(roomKey) {
  const room = GUILD_HOME_ROOMS.find(item => item.key === roomKey);
  return room?.feature || room?.purchaseFeature || room?.purchaseAny?.[0] || null;
}

export function resolveGuildHomeTheme(requested, features = []) {
  const theme = Object.hasOwn(GUILD_HOME_THEMES, requested) ? GUILD_HOME_THEMES[requested] : null;
  return theme && (!theme.feature || features.includes(theme.feature)) ? requested : 'default';
}

export function guildHomeImage(theme, room = 'hall', thumbnail = false) {
  const safeTheme = Object.hasOwn(GUILD_HOME_THEMES, theme) ? theme : 'default';
  const imageRoom = GUILD_HOME_ROOMS.find(item => item.key === room)?.artRoom || room;
  const safeRoom = ['hall', 'shop', ...GUILD_HOME_ROOMS.map(item => item.key)].includes(room) ? imageRoom : 'hall';
  return imageResolver(safeTheme, safeRoom, thumbnail);
}

export function getGuildBoostPercent(features = []) {
  return Math.max(0, ...features.filter(feature => /^EXP_BOOST_[1-5]$/.test(feature)).map(feature => Number(feature.slice(-1))));
}
